var nanobus = require('nanobus');
var ToggleButton = /** @class */ (function () {
    function ToggleButton(element) {
        this.element = element;
        this.events = nanobus();
        this.init();
    }
    ToggleButton.prototype.init = function () {
        var _this = this;
        this.element.addEventListener('click', function (e) {
            e.stopPropagation();
            if (_this.isOpen()) {
                _this.triggerClose();
            }
            else {
                _this.triggerOpen();
            }
        });
    };
    ToggleButton.prototype.isOpen = function () {
        return this.element.classList.contains('-open');
    };
    ToggleButton.prototype.triggerOpen = function () {
        this.element.classList.add('-open');
        this.events.emit('open');
    };
    ToggleButton.prototype.triggerClose = function () {
        this.element.classList.remove('-open');
        this.events.emit('close');
    };
    return ToggleButton;
}());
export default ToggleButton;
